import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  background?: 'white' | 'cream';
};
export function Testimonials({
  testimonials,
  title = 'What coaches are saying',
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-ice';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-187" data-mp="370ajwrjw8kg4">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-188" data-mp="31ybfrfgbxji4">
        <div className="text-center" data-id="element-189" data-mp="2x09z116dlw9t">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-190" data-mp="2x1bh3plt7j11">
            Coach to coach
          </p>
          <h2 className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-191" data-mp="v9gbnrq5car9">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-192" data-mp="qa3pl973n7pq">
            Rated 4.9/5 by 1,200+ coaches across school, all-star and rec
            programs.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-193" data-mp="m5kmap8g0vcy">
          {testimonials.map((item, i) => <figure key={i} className="rounded-2xl border border-ice-dark bg-white p-5 shadow-card" data-id="element-194" data-mp="78ttwzx6sjwu" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-195" data-mp="c8oll5osddiy">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-ice-dark" data-id="element-196" data-mp="zyiw3glmuq01" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy text-[11px] font-bold text-white" data-id="element-197" data-mp="1ivk2n5uu4y63">
                    {item.author.replace(/[^A-Za-z]/g, '').slice(0, 2).toUpperCase() || 'CC'}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-198" data-mp="1sk7hwjfxd5zf">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-199" data-mp="1jj0ya1hzbf1y" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-sm italic text-ink" data-id="element-200" data-mp="19qbt1od0uxf2">
                {item.quote}
              </blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-201" data-mp="10s01nk4bzvlk">
                <span className="block text-[13px] font-bold not-italic text-ink" data-id="element-202" data-mp="10pnbijof6exf">
                  {item.author}
                </span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}